import type { BillingInfoFormValues } from "@circle-react/components/Paywalls/CommunityMembers/BillingInfo/BillingInfoFormValues";
import { getTaxIdTypeLabelByTaxIdTypeAndCountryCode } from "@circle-react/utils/paywalls/taxId/helpers";

export const serializeDefaultCommunityMemberBillingInfo = (
  billingInfo: BillingInfoFormValues,
): BillingInfoFormValues => ({
  address_city: billingInfo?.address_city,
  address_complete: billingInfo?.address_complete,
  address_country: billingInfo?.address_country,
  address_line1: billingInfo?.address_line1,
  address_line2: billingInfo?.address_line2,
  address_postal_code: billingInfo?.address_postal_code,
  address_state: billingInfo?.address_state,
  business_name: billingInfo?.business_name,
  tax_id_type_label: getTaxIdTypeLabelByTaxIdTypeAndCountryCode(
    billingInfo?.tax_id_type,
    billingInfo?.address_country,
  ),
  tax_id_type: billingInfo?.tax_id_type,
  tax_id_value: billingInfo?.tax_id_value,
});
